// extracted by mini-css-extract-plugin
export default {"emoji-picker":"EmojiPicker_emoji-picker__Ojn+w","emoji-picker-grid":"EmojiPicker_emoji-picker-grid__r+RIK","emoji-picker-option":"EmojiPicker_emoji-picker-option__l6hyK"};